import { useEffect, useState } from 'react';
import { getBrowserVersion } from '../pages/videoCall/utils';
import { isPlatform } from '@ionic/react';

export function useIsSafariIsNotSupported() {
  const [isSafariIsNotSupported, setIsSafariIsNotSupported] = useState(false);
  const [isOpenNotSupportedModal, setIsOpenNotSupportedModal] = useState(false);

  useEffect(() => {
    const [browser] = getBrowserVersion().split(' ');
    if (isPlatform('desktop') && browser.includes('Safari')) return setIsSafariIsNotSupported(true);
  }, []);

  return {
    isOpenNotSupportedModal,
    isSafariIsNotSupported,
    setIsOpenNotSupportedModal
  };
}
